import {
  ApiUtility,
  IApiListResult,
  IApiResponse,
} from "../../Utilities/ApiUtility.axios";
import { LedgerStatus } from "./LedgerService";
import { IIdNameUnitModel, Voucher_Type } from "./VoucherServices";

export interface IItemList extends IIdNameModel {
  sno: number;
  number: string;
  isService: boolean;
  isTaxable: boolean;
  taxRate?: string;
  rate: number;
  hsnSacCode?: string;
  sPrice?: number;
  pPrice?: number;
  itemStatus: ItemStatus;
  qty: number;
  tAmount?: number;
  openingStock?: IItemOpeningStockDetails;
  trackingType: Item_Nature;
  barCode?: string;
  unit: IIdNameUnitModel;
  unitDetail?: IUnitDetailResponse;
  batchItem?: IBatchItem[];
  serialItem?: ISerialItem[];
}

export interface IItemInvCloOpResponse extends IIdNameModel {
  sno: number;
  // number: string;
  isService: boolean;
  isTaxable: boolean;
  taxRate?: string;
  rate: number;
  purchasePrice?: number;
  salesItemPrice?: number;
  qty: number;
  tAmount?: number;
  stockValue?: number;
  openingStock?: IItemOpeningStockDetails;
  batchItem?: IBatchItem[];
  serialItem?: ISerialItem[];
  trackingType: Item_Nature;
  invDetail?: IItemInventory[];
}

export interface IItemInventory {
  item: IItemInvDetail;
  adjust: Adjust_Type;
  qty: number;
  price: number;
  tAmount: number;
  date?: string;
  voucherRef?: IIdNameModel;
}
export interface IItemInvDetail extends IIdNameModel {
  batchId?: number;
  serialId?: number;
  residualValue?: number;
  warrantyExpDate?: string;
  identityCode?: string;
  depreciationStartDate?: string;
  location?: string;
  empId?: string;
}
export interface IBatchItem {
  id: number;
  batchNumber: string;
  mfDate?: string;
  expiryDate?: string;
  openingQuantity?: number;
  purchaseQty?: number;
  saleQty?: number;
  availableQty?: number;
  salesPrice?: number;
  purchasePrice?: number;
  itemAddType?: ItemAdd_Type;
  status: BatchItemStatus;
}

export interface IItemWithUnit extends IItemList {
  unitId: number;
  unitName: string;
  unitType: UnitTypes;
  unitShortName: string;
  allowFractionalQty: boolean;
  qtyDecimalPlaces: number;
  unitDetail?: IUnitDetailResponse;
}

export interface ISerialItem {
  id: number;
  modalNo?: string;
  serialNumber?: string;
  warranty?: string;
  itemAddType?: ItemAdd_Type;
  status: BatchItemStatus;
}
export interface IItemOpeningStockDetails {
  quantity: number;
  price?: number;
  totalAmount?: number;
  date?: string;
}

// export interface IUnitListResponse {
//   sno: number;
//   id: number;
//   name: string;
//   type: UnitTypes;
//   shortName: string;
//   system: boolean;
//   //  isBaseUnit: boolean;
//   parentUnitName?: string;
//   parentUnitId?: number;
//   conversionFactor?: number;
//   isComposite: boolean;
//   compositeUnits?: ICompositeUnitRequest[];
//   compositeStructure?: string;
//   symbol?: string;
//   unitCategory: UnitCategory;
//   DecimalPlaces: number;
//   allowFractional: boolean;
//   displayName?: string;
// }

export interface IUnitRequest {
  name: string;
  shortName: string;
  type: UnitTypes;
  decimalPlaces: number;
  unitCategory: UnitCategory;
  id?: number;
  system?: boolean;
  compositeUnits?: ICompositeUnitRequest[] | null;
}
export interface IUnitListResponse extends IUnitRequest {
  sno: number;
  compositeStructure?: string;
}

export interface ICompositeUnitRequest {
  unitId: number;
  unitName: string;
  shortName: string;
  decimalPlaces: number;
  quantity: number;
  order: number;
}

export interface IUnitConversionRequest {
  fromUnitId: number;
  toUnitId: number;
  quantity: number;
}

export interface IUnitSearchModel {
  unitName?: string;
  unitNameDropEnum?: number;
  type?: UnitTypes[];
  shortName?: string;
  shortNameDropEnum?: number;
  //  isBaseUnit?: boolean;
  isComposite?: boolean;
  parentUnitId?: number;
  unitCategory?: UnitCategory;
}

export enum CAPItemTypes {
  Sales,
  Purchase,
}
export enum ItemValuation_Type {
  FIFO,
  LIFO,
  WeightedAverage,
}
export enum Adjust_Type {
  Add = 1,
  Reduce = 2,
  OpeningStock = 3,
  Transfer = 4,
  ClosingStock,
}
export enum ItemInvStatus {
  All,
  Sales,
  Purchase,
  AdjustItem,
}

export enum InventoryType {
  Add = 0,
  Update = 1,
  Delete = 2,
  Active = 3,
}

export enum UnitCategory {
  Simple = 0,
  Compound = 1,
}

export enum ItemType {
  All,
  SalesItems,
  PurchaseItems,
  SalesGoods,
  SalesService,
  PurchaseGoods,
  PurchaseService,
  AllItemGoods,
  AllItemServices,
  OnlySalesItems,
  OnlyPurchaseItems,
}

export enum UnitTypes {
  Length,
  Weight,
  Capacity,
  Countables,
  Time,
  All = 10,
}

export const ItemValuationMethodOption = [
  {
    value: ItemValuation_Type.FIFO,
    label: "FIFO",
    title: "First in first out",
  },
  {
    value: ItemValuation_Type.LIFO,
    label: "LIFO",
    title: "Last in first out",
  },
  {
    value: ItemValuation_Type.WeightedAverage,
    label: "WAVG",
    title: "Weighted average",
  },
];
export const UnitTypesOption = [
  {
    value: UnitTypes.Length,
    label: "Length",
  },
  {
    value: UnitTypes.Weight,
    label: "Weight",
  },
  {
    value: UnitTypes.Capacity,
    label: "Capacity",
  },
  {
    value: UnitTypes.Countables,
    label: "Countables",
  },
  {
    value: UnitTypes.Time,
    label: "Time",
  },
];

export const UnitCategoryOptions = [
  {
    value: UnitCategory.Simple,
    label: "Simple",
  },
  {
    value: UnitCategory.Compound,
    label: "Compound",
  },
];

export enum FilterCategoryInItems {
  AvailableItems,
  NotAvailableItems,
}

export enum DiscountSalesType {
  Percentage,
  Amount,
}

export enum ItemStatus {
  All = 0,
  Active = 1,
  Inactive = 2,
  Draft = 3,
  Delete = 4,
}

export enum Item_Nature {
  Normal,
  Batch,
  Serial,
}

export enum ItemAdd_Type {
  Opening,
  New,
  All = 5,
}
export enum BatchItemStatus {
  Available,
  Sold,
  Expired,
  Damaged,
  Returned,
}

export interface isBulkActiveItemsList {
  inActiveListItemsId: string[];
  activeListItemsId: string[];
}
export interface IOpeningEntryItemsList {
  item: {
    id: string;
    name: string;
    batchItems?: IIdPriceQtyModel[];
    serialItems?: IIdPriceQtyModel[];
  };
  trackingType: Item_Nature;
  qty: number;
  price: number;
}
export interface IIdPriceQtyModel {
  id: number;
  price: number;
  qty: number;
}
export interface IIdNameModel {
  id: string;
  name: string;
}
export interface IUnitDetailResponse {
  id: number;
  name: string;
  type: UnitTypes;
  shortName: string;
  system: boolean;
  //  isBaseUnit: boolean;
  parentUnitId?: number;
  conversionFactor?: number;
  compositeUnits?: ICompositeUnitComponent[];
  isComposite: boolean;
  compositeStructure?: string;
  unitCategory: UnitCategory;
  decimalPlaces: number;
}
export interface ICompositeUnitComponent {
  unitId: number;
  unitName: string;
  shortName: string;
  quantity: number;
  order: number;
  decimalPlaces: number;
}

class ItemsServices {
  itemRoute = `/V1/API/Billing/Acc_Item`;

  searchItem = (
    clientId: string,
    term: string = "",
    type: CAPItemTypes,
    barCodeSearch?: string,
    voucherType?: Voucher_Type,
    partyId?: string
  ) =>
    ApiUtility.getResult(
      `${this.itemRoute}/${clientId}/Search?term=${term ?? ""}`,
      {
        type,
        barCodeSearch,
        voucherType,
        partyId,
      }
    );
  PostOpeningItemInventory = (
    clientId: string,
    itemsList: IOpeningEntryItemsList[],
    voucherRef: IIdNameModel,
    voucherDate: string
  ) =>
    ApiUtility.post(`${this.itemRoute}/${clientId}/AddOpeningItemInventory`, {
      itemsList,
      voucherRef,
      voucherDate,
    });

  getItem = (clientId: string | undefined, id?: string) =>
    ApiUtility.get(`${this.itemRoute}/${clientId}/Get${id ? `?id=${id}` : ""}`);

  // https: //localhost:7142/V1/API/Acc_Item/wsdsafert34t/GetSerialNo?serialNo=345346taertaer
  getSerialNo = (clientId: string | undefined, serialNo?: string) =>
    ApiUtility.get(
      `${this.itemRoute}/${clientId}/GetSerialNo${
        serialNo ? `?serialNo=${serialNo}` : ""
      }`
    );

  getBetchNo = (clientId: string | undefined, checkExistBatchNo: any) =>
    ApiUtility.get(
      `${this.itemRoute}/${clientId}/GetBatchNo?batchNo=${checkExistBatchNo}`
    );

  getListItems = (
    clientId: string,
    start: number,
    length: any,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    status?: any,
    type?: ItemType,
    gstRate?: number[],
    itemInventory?: boolean,
    itemStatus?: ItemStatus,
    categoryId?: string,
    searchColumnCount?: number,
    requestModel?: any,
    itemAddType: ItemAdd_Type = ItemAdd_Type.All
  ) =>
    ApiUtility.getResult<IApiListResult<IItemList>>(
      `${this.itemRoute}/${clientId}`,
      {
        start,
        length,
        sortCol,
        sortDir,
        search,
        type,
        status,
        gstRate,
        itemInventory,
        itemStatus,
        categoryId,
        searchColumnCount,
        requestModel,
        itemAddType,
      }
    );

  getItemDetails = (clientId: string, itemId: string) =>
    ApiUtility.getResult(
      `${this.itemRoute}/${clientId}/ItemIntDetails/${itemId}`
    );

  // getItemsClosingInvDetail = (clientId: string, from?: string, to?: string) =>
  //   ApiUtility.getResult<IItemInvDetail[]>(
  //     `${this.itemRoute}/${clientId}/GetItemsClosingInventoryDetails`
  //   );

  PostItems = (param: any, clientId: string, id?: string, config?: string) =>
    ApiUtility.postForm(
      `${this.itemRoute}/${id ? clientId + "/" + id : clientId}`,
      param
      // config
    );

  deleteItem = (clientId: string, itemId: string) =>
    ApiUtility.delete(`${this.itemRoute}/${clientId}/${itemId}`);

  // https: //localhost:7142/V1/API/Acc_Item/677e845c7151fa980b41c2b4/IsActive?id=678a30bc55798483ce90751c&itemStatus=2
  isActiveItem = (
    clientId: string,
    id: string,
    itemStatus?: ItemStatus,
    itemsIdList?: isBulkActiveItemsList
  ) =>
    ApiUtility.post(
      `${this.itemRoute}/${clientId}/IsActive?id=${id}&itemStatus=${itemStatus}`,
      {
        itemsIdList,
      }
    );

  // https://localhost:7142/V1/API/Acc_Item/6749549bdb6d377cad9c59d6/GetCategoryToItemList/674efcfeac3640294815cd08

  getCategoryToItemList = (
    companyId: string | undefined,
    categoryId: string,
    isCategoryInItem: FilterCategoryInItems,
    start: number,
    length: number,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.get(
      `${this.itemRoute}/${companyId}/GetCategoryToItemList/${categoryId}`,
      {
        isCategoryInItem,
        start,
        length,
        search,
        sortCol,
        sortDir,
        status,
      }
    );

  moveCategoryData = (
    companyId: string | undefined,
    categoryId: string,
    isCategoryInItem: FilterCategoryInItems,
    AddOrRemoveItemsId: string[]
  ) =>
    ApiUtility.post(
      `${this.itemRoute}/${companyId}/MoveToThisCategoryItems/${categoryId}?isCategoryInItem=${isCategoryInItem}`,
      {
        AddOrRemoveItemsId,
      }
    );

  getBarCode = (companyId: string | undefined) =>
    ApiUtility.post(`${this.itemRoute}/${companyId}/GenerateBarcode`, "");
  // "https://localhost:7142/V1/API/Acc_ItemInventory/6463611020350584c0d5c017/Get?itemId=6501a570643413cc49d1164c&start=0&length=15&status=0";

  // https: //localhost:7142/V1/API/Acc_ItemInventory/6463611020350584c0d5c017/Get?itemId=6465e265731bc731fb04ada8&start=0&length=15&type=1&type=2

  // "https://localhost:7142/V1/API/Acc_ItemInventory/6463611020350584c0d5c017/Get?itemId=651bc9472706aed188a399a7&start=0&length=15&from=01%2F09%2F2023&to=30%2F09%2F2023&type=1";
  inventoryRoute = `/V1/API/Billing/Acc_ItemInventory`;

  getItemInventoryList = (
    clientId: string | undefined,
    itemId: string,
    start?: number,
    length?: number,
    from?: string,
    to?: string,
    sortCol?: string,
    sortDir?: string,
    type?: number[],
    partyId?: string[]
  ) =>
    ApiUtility.get(`${this.inventoryRoute}/${clientId}/Get`, {
      itemId,
      start,
      length,
      from,
      to,
      sortCol,
      sortDir,
      type,
      partyId,
    });

  // https: //localhost:7142/V1/API/Acc_ItemInventory/64f96b34ef29cde5ee5e45fe?Type=0
  // /localhost:7142/V1/API/Acc_ItemInventory/64f96b34ef29cde5ee5e45fe/6509410c5f4e3d2158fbed7d?Type=0
  addItemInventory = (
    param: any,
    clientId: string | undefined,
    type?: InventoryType,
    id?: string
  ) =>
    ApiUtility.post(
      `${this.inventoryRoute}/${
        id ? clientId + "/" + id : clientId
      }?Type=${type}`,
      param
    );

  // https://localhost:7142/V1/API/Acc_ItemInventory/64f96b34ef29cde5ee5e45fe/650941ff5f4e3d2158fbed80
  getItemInventory = (clientId: string | undefined, id: string) =>
    ApiUtility.get(`${this.inventoryRoute}/${clientId}/${id}`);

  // Unit APi
  // https://localhost:7142/V1/API/Acc_Units/6463611020350584c0d5c017?start=0&length=150

  unitRoute = `/V1/API/Billing/Acc_Units`;
  getUnitsList = (
    companyId: string | undefined,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    searchColumnCount?: number,
    requestModel?: any
    // selType?: UnitTypes
  ) =>
    ApiUtility.get<IApiResponse<IApiListResult<IUnitListResponse>>>(
      `${this.unitRoute}/${companyId}`,
      {
        start,
        length,
        sortCol,
        sortDir,
        search,
        searchColumnCount,
        requestModel,
        // selType,
      }
    );

  addUnit = (param: IUnitRequest, companyId: string) =>
    ApiUtility.post<IApiResponse<IUnitRequest>>(
      `${this.unitRoute}/${companyId}`,
      param
    );

  updateUnit = (param: IUnitRequest, clientId: string, id: number) =>
    ApiUtility.post<IApiResponse<IUnitRequest>>(
      `${this.unitRoute}/${clientId}/${id}`,
      param
    );

  // https://localhost:7142/V1/API/Acc_Units/6463611020350584c0d5c017/Units
  // https: //localhost:7142/V1/API/Acc_Units/6463611020350584c0d5c017/Units/44
  postUnit = (param: any, clientId?: string, id?: number) =>
    ApiUtility.post(`${this.unitRoute}/${clientId}/${id ? id : ""}`, param);

  getUnit = (clientId?: string, id?: number) =>
    ApiUtility.get(`${this.unitRoute}/${clientId}`, id);

  deleteUnitId = (clientId: string | undefined, unitId: any) =>
    ApiUtility.delete(`${this.unitRoute}/${clientId}/${unitId}`);

  // ItemGroup APi
  // https://localhost:7142/V1/API/Acc_ItemGroups/6463611020350584c0d5c017?start=0&length=150

  itemGroupRoute = `/V1/API/Billing/Acc_ItemGroups`;
  getItemGroupsList = (
    companyId: string | undefined,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    groupId?: string,
    groupSearch?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.get(`${this.itemGroupRoute}/${companyId}/GetList`, {
      search,
      sortCol,
      sortDir,
      groupId,
      groupSearch,
      status,
    });

  postItemGroup = (param: any, clientId?: string, itemGroupId?: string) =>
    ApiUtility.post(
      `${this.itemGroupRoute}/${clientId}/${itemGroupId ? itemGroupId : ""}`,
      param
    );

  // ItemLocation APi
  // https://localhost:7142/V1/API/Acc_ItemLocations/6463611020350584c0d5c017?start=0&length=150
  itemLocationRoute = `/V1/API/Billing/Acc_ItemLocations`;
  getItemLocationsList = (
    companyId: string | undefined,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    status?: LedgerStatus
  ) =>
    ApiUtility.get(`${this.itemLocationRoute}/${companyId}/GetList`, {
      search,
      sortCol,
      sortDir,
      status,
    });

  getItemLocationsDropDownList = (companyId: string | undefined) =>
    ApiUtility.get(`${this.itemLocationRoute}/${companyId}/GetList`);

  postItemLocation = (param: any, clientId?: string, itemLocationId?: string) =>
    ApiUtility.post(
      `${this.itemLocationRoute}/${clientId}/${
        itemLocationId ? itemLocationId : ""
      }`,
      param
    );

  deleteLocationById = (
    companyId: string | undefined,
    itemLocationId: string
  ) =>
    ApiUtility.delete(
      `${this.itemLocationRoute}/${companyId}/${itemLocationId}`
    );
}

// eslint-disable-next-line new-parens
export default new ItemsServices();
